(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/views/tt-layout-view.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/views/tt-layout-view.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.tt.views.TTLayout = Marionette.View.extend({

    className: 'tt-start padding-xs-1 padding-sm-2 padding-lg-4 bg-white',

    template: function(data) {
      return svs.tt.templates.layout(data);
    },

    regions: {
      content: '#tt-content'
    },

    initialize: function(options) {
      this.productSetting = options.productSetting;
    },

    onRender: function() {
      var productView = new svs.tt.views.Draws({
        model: svs.tt.draws,
        productSetting: this.productSetting
      });

      this.showChildView('content', productView);
    }
  });
})(Backbone, _, svs);


 })(window);